import React, { Component } from "react";
import Switch from "react-toggle-switch";
import Cards from "../cards-main";
import PropTypes from "prop-types";

class Toggle extends Component {
  constructor(props) {
    super(props);

    this.state = {
      latestClick: true,
      popularClick: false,
      latestClass: "active",
      popularClass: "toggleBtn",
      active: "latest",
      showLatestArticles: window.showLatestTab,
      showPopularArticles: window.showPopularTab
    };

    this.handleLatestClick = this.handleLatestClick.bind(this);
    this.handlePopularClick = this.handlePopularClick.bind(this);
    this.toggleSwitch = this.toggleSwitch.bind(this);
  }

  toggleSwitch() {
    this.setState(prevState => {
      return {
        popularClick: !prevState.popularClick,
        active: !prevState.popularClick ? "popular" : "latest"
      };
    });
  }

  handleLatestClick() {
    this.setState({
      latestClick: true,
      popularClick: false,
      latestClass: "active",
      popularClass: "toggleBtn",
      active: "latest"
    });
  }

  handlePopularClick() {
    this.setState({
      popularClick: true,
      latestClick: false,
      latestClass: "toggleBtn",
      popularClass: "active",
      active: "popular"
    });
  }

  render() {
    return (
      <div className="togglePage hmContentHub">
        {this.state.showLatestArticles && this.state.showPopularArticles && (
          <div className="popularLatestBtns">
            <button
              className={this.state.latestClass}
              onClick={this.handleLatestClick}
            >
              Latest
            </button>
            <button
              className={this.state.popularClass}
              onClick={this.handlePopularClick}
            >
              Popular
            </button>
          </div>
        )}
        <div className="toggleContent">
          {this.state.showLatestArticles && this.state.showPopularArticles && (
            <div className={this.state.active + " mobileOnly"}>
              <h2 className="toggleLatest">Latest</h2>
              <Switch
                onClick={this.toggleSwitch}
                on={this.state.popularClick}
              />
              <h2 className="togglePopular">Popular</h2>
            </div>
          )}

          <div className={this.state.active}>
            {this.state.showLatestArticles && (
              <div className="latestLayout">
                <Cards api={this.props.api.latest} loadMore={true} />
              </div>
            )}
            {this.state.showPopularArticles && (
              <div className="popularLayout">
                <Cards api={this.props.api.popular} loadMore={true} />
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

Toggle.propTypes = {
  api: PropTypes.object
};

export default Toggle;
